import { motion, useReducedMotion } from "framer-motion";

const easing = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 28, className = "" }) {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? { opacity: 0 } : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, delay, ease: easing }}
    >
      {children}
    </motion.div>
  );
}

// Masked line-by-line reveal. Pass an array of strings (lines).
export function MaskedLines({ lines, className = "", lineClassName = "", delay = 0, playOnLoad = true }) {
  const reduce = useReducedMotion();
  const trigger = playOnLoad
    ? { initial: "hidden", animate: "show" }
    : { initial: "hidden", whileInView: "show", viewport: { once: true, margin: "-60px" } };

  return (
    <span className={className} aria-label={lines.join(" ")}>
      {lines.map((line, i) => (
        <span key={i} className="reveal-mask" aria-hidden="true">
          <motion.span
            className={`block ${lineClassName}`}
            {...trigger}
            variants={{
              hidden: reduce ? { opacity: 0 } : { y: "110%" },
              show: {
                y: "0%",
                opacity: 1,
                transition: { duration: 0.9, delay: delay + i * 0.11, ease: easing },
              },
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}
